// src/components/ui/input.jsx
import React from 'react';
import classNames from 'classnames';

export function Input({ type = 'text', value, onChange, placeholder, className = '', ...props }) {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={classNames(
        'border border-gray-300 rounded-md px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500',
        className
      )}
      {...props}
    />
  );
}

export default Input;